import React, { useEffect, useState, useRef} from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import JoditEditor from "jodit-react"


const FaleConoscoEdit = (props) => {

    var history = useHistory()

    var faleConosco_id = props.match.params.faleConosco_id

    var us_codigo = sessionStorage.getItem('us_codigo')

    var [dataHora, setDataHora] = useState()
    var [assuntoDescri, setAssuntoDescri] = useState()
    var [nome, setNome] = useState()
    var [email, setEmail] = useState()
    var [mensagem, setMensagem] = useState()
    var [organizacao, setOrganizacao] = useState()
    var [situacao, setSituacao] = useState()
    var [situacaoDescri, setSituacaoDescri] = useState()
    var [corSituacao, setCorSituacao] = useState()
    var [resposta, setResposta] = useState()
    
    var [resolvido, setResolvido] = useState(false)
    

    var [texto, setTexto] = useState()

    const editor = useRef(null)
    const [content, setContent] = useState('')
    

    const [config, setConfig] = useState({
        readonly: situacao == 'R' ? true : false,
        toolbar: true,
        height: 250,
        placeholder: 'Escreva aqui...',
      })



    async function carregaDados() {

        await api.get(`faleConosco/${faleConosco_id}`).then((result) => {

            //console.log(result.data)

            var data = result.data[0]

            setDataHora(data.dataHora)
            setNome(data.nome)
            setEmail(data.email)
            setMensagem(data.mensagem)
            setOrganizacao(data.organizacao)
            setContent(data.resposta)
            setSituacao(data.situacao)
            setResolvido(data.resolvido == null ? false : data.resolvido)
         
            setAssuntoDescri(data.assunto_descri)

            

            var situacao = data.situacao


            switch (situacao) {

                case null:

                    atualizaSituacao('P')

                break

                case 'R':

                    setSituacaoDescri(`Respondido em ${data.dataHoraResposta} por ${data.usuarioResposta}`)
                    setCorSituacao('#e3ebbe')
                
                break

                case 'P':

                    setSituacaoDescri('Pendente')
                    setCorSituacao('#e3ebbe')

                break

            }
            

        }).catch((err) => {

            console.log(err.response)

        })

    }


    async function atualizaResolvido(resolvido) {


        var dataPost = {

            resolvido: resolvido
        
        }

        //console.log(dataPost)
        //return false

        await api.put(`faleConoscoResolvido/${faleConosco_id}`, dataPost).then((result) => {

            console.log(result.data)

            if (result.data.alerta == 'ok' && situacao == null) {

                window.toastr.success('Registro salvo com sucesso!')
                

            }

            setResolvido(resolvido)


        }).catch((err) => {

            console.log(err.response)

        })



    }


    async function atualizaSituacao(situacao) {

        var dataPost = {

            situacao: situacao

        }

        await api.put(`faleConoscoSituacao/${faleConosco_id}`, dataPost).then((result) => {

            console.log(result.data)
            if (result.data.alerta == 'ok' && situacao == null) {

                window.toastr.success('Mensagem deixada como <b>não lida</b>!')

            }


        }).catch((err) => {

            console.log(err.response)

        })


    }


    function responder() {

        var dataPost = {

            resposta: texto,   
            us_codigo: us_codigo,         

        }

        //console.log(dataPost)

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'blue',
		    title: 'Confirmação',
		    content: 'Confirma o envio da resposta por e-mail?',
		    buttons: {
		        Sim: function () {


                    api.put(`faleConosco/${faleConosco_id}`, dataPost).then((response) => {

                        //console.log(response.data)
                        //if (response.data.alerta == 'ok') {

                            atualizaSituacao('R')
                            window.toastr.success('Respondido com sucesso!')
                            history.push('/FaleConosco')

                        //}
                        

                    }).catch((err) => {
                        console.log(err.response)
                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });




    }


    useEffect(() => {


        carregaDados()


    }, [])


    return (

        <div>


        
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Comunicação</h1>
                    <small>Fale Conosco</small>
                    
                </div>
            </div>


            <div className="row">

                <div class="col-md-3">
                    <div class="form-group">
                        <label>Data/Hora</label>
                        <input type="text" class="form-control" placeholder="" value={dataHora} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="form-group">
                        <label>Nome completo</label>
                        <input type="text" class="form-control" placeholder="" value={nome} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Organização</label>
                        <input type="text" class="form-control" placeholder="" value={organizacao} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>E-mail</label>
                        <input type="text" class="form-control" placeholder="" value={email} readOnly style={{ cursor: 'pointer'}} onClick={() => window.location.href=`mailto:${email}`} />
                                        
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label>Assunto</label>
                        <input type="text" class="form-control" placeholder="" value={assuntoDescri} readOnly  />
                                        
                    </div>
                </div>

                <div class="col-md-12" >
                    <div class="form-group">
                        <label>Situação</label>
                        <input type="text" class="form-control" placeholder="" value={situacaoDescri} readOnly style={{  backgroundColor: corSituacao}} />
                                        
                    </div>
                </div>
                <div class="col-md-12" >
                    <div class="form-group">
                        <label>Resolvido</label>
                        <input type="text" class="form-control" placeholder="" value={resolvido == true ? 'Sim' : 'Não'} readOnly style={{  backgroundColor: resolvido == true ? '#b4f0a3' : '#f0ada3'}} />
                                        
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Mensagem</label>
                        <textarea class="form-control" placeholder="" rows="3" value={mensagem} readOnly />
                                        
                    </div>
                </div>
                

                <div class="col-md-12">

                    <div class="form-group">
                        <label>Resposta</label>
                                
                        <JoditEditor 
                            ref={editor}
                            value={content}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                            onChange={newContent => {}}
                            
                        />

                                        
                    </div>

                </div>


            </div>

            <div class="col-md-12">

                    <br/>
                                    
                    <button type="button" class="btn btn-info" onClick={() => history.push('/FaleConosco')}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-warning" onClick={() => atualizaSituacao(null)}  style={{ display: situacao == 'R' ? 'none' : 'table-row'}}>Deixar como não lido</button>&nbsp;
                    
                    <button type="button" class='btn btn-danger' onClick={() => atualizaResolvido(false)} >Não resolvido</button>&nbsp;
                    <button type="button" class='btn btn-success' onClick={() => atualizaResolvido(true)} >Resolvido</button>&nbsp;

                    <button type="button" class="btn btn-primary" onClick={() => responder()} style={{ display: situacao == 'R' ? 'none' : 'table-row'}}>Responder</button>
                </div>

        </div>

    )

}


export default FaleConoscoEdit